import React, { useState, useEffect } from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  Alert,
} from 'reactstrap';
import axios from 'axios';

const BASE_URL = process.env.REACT_APP_BASE_URL;

const ManualBloodPressureModal = ({ isOpen, toggle, subjectId, onBloodPressureAdded }) => {
  const [systolic, setSystolic] = useState('');
  const [diastolic, setDiastolic] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [errors, setErrors] = useState({
    systolic: '',
    diastolic: ''
  });
  const [touched, setTouched] = useState({
    systolic: false,
    diastolic: false
  });

  useEffect(() => {
    if (isOpen) {
      setSystolic('');
      setDiastolic('');
      setError('');
      setSuccess(false);
    }
  }, [isOpen]);
  const validateSystolic = (value) => {
    const sys = parseInt(value);
    if (value === '') return 'Systolic pressure is required.';
    if (isNaN(sys)) return 'Systolic pressure must be a number.';
    if (sys < 40 || sys > 300) return 'Systolic pressure must be between 40 and 300.';
    return '';
  };

  const validateDiastolic = (value) => {
    const dia = parseInt(value);
    if (value === '') return 'Diastolic pressure is required.';
    if (isNaN(dia)) return 'Diastolic pressure must be a number.';
    if (dia < 10 || dia > 200) return 'Diastolic pressure must be between 10 and 200.';
    return '';
  };
  const handleSystolicChange = (e) => {
    const value = e.target.value;
    setSystolic(value);
    if (touched.systolic) {
      setErrors(prev => ({
        ...prev,
        systolic: validateSystolic(value)
      }));
    }
  };
  const handleDiastolicChange = (e) => {
    const value = e.target.value;
    setDiastolic(value);
    if (touched.diastolic) {
      setErrors(prev => ({
        ...prev,
        diastolic: validateDiastolic(value)
      }));
    }
  };

  const handleBlur = (field) => {
    setTouched(prev => ({
      ...prev,
      [field]: true
    }));

    if (field === 'systolic') {
      setErrors(prev => ({
        ...prev,
        systolic: validateSystolic(systolic)
      }));
    } else if (field === 'diastolic') {
      setErrors(prev => ({
        ...prev,
        diastolic: validateDiastolic(diastolic)
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Set all fields as touched
    setTouched({ systolic: true, diastolic: true });

    // Validate all fields
    const systolicError = validateSystolic(systolic);
    const diastolicError = validateDiastolic(diastolic);

    setErrors({
      systolic: systolicError,
      diastolic: diastolicError
    });

    if (systolicError || diastolicError) {
      return;
    }


    try {
      await axios.post(`${BASE_URL}web/manualBloodPressure`, {
        subjectId,
        systolic: parseInt(systolic),
        diastolic: parseInt(diastolic),
      });

      setSuccess(true);
      onBloodPressureAdded();
      setTimeout(() => {
        toggle();
      }, 1500);
    } catch (error) {
      console.error('Error submitting blood pressure:', error);
      setError('Failed to submit blood pressure. Please try again.');
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Enter Blood Pressure</ModalHeader>
      <ModalBody>
        {error && <Alert color="danger">{error}</Alert>}
        {success && <Alert color="success">Blood pressure submitted successfully!</Alert>}
        <Form onSubmit={handleSubmit}>
          <FormGroup>
            <Label for="systolic">Systolic Pressure h (mmHg)</Label>
            <Input
              type="number"
              id="systolic"
              value={systolic}
              onChange={handleSystolicChange}
              onBlur={() => handleBlur('systolic')}
              placeholder="Enter systolic pressure"
              min="40"
              max="300"
              required
              className={`w-full ${errors.systolic && touched.systolic ? 'border-red-500' : ''}`}
            />
{errors.systolic && touched.systolic && (
  <p className="text-danger small">{errors.systolic}</p>
)}
          </FormGroup>
          <FormGroup>
            <Label for="diastolic">Diastolic Pressure (mmHg)</Label>
            <Input
              type="number"
              id="diastolic"
              value={diastolic}
              onChange={handleDiastolicChange}
              onBlur={() => handleBlur('diastolic')}
              placeholder="Enter diastolic pressure"
              min="10"
              max="200"
              required
              className={`w-full ${errors.diastolic && touched.diastolic ? 'border-red-500' : ''}`}
            />
{errors.diastolic && touched.diastolic && (
  <p className="text-danger small">{errors.diastolic}</p>
)}
          </FormGroup>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>Cancel</Button>
        <Button color="primary" onClick={handleSubmit}>Submit</Button>
      </ModalFooter>
    </Modal>
  );
};

export default ManualBloodPressureModal;
